import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {EXPIRATION_EXERCISE_ASSIGNMENT_1} from "../FxeQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const ExpirationExerciseAssignment1 = "tfExpirationExerciseAssignment1Question";

export function expirationExerciseAssignment1() {
    return {
        templateUrl: "app/quiz/fxe/questions/ExpirationExerciseAssignment1.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: ExpirationExerciseAssignment1Controller
    };
}

export class ExpirationExerciseAssignment1Controller extends FxeQuizQuestionController {
    public config = EXPIRATION_EXERCISE_ASSIGNMENT_1;
}
